import React, {FC} from 'react';
import {VisualizationsTheme} from '@epic-visualizations/theme';
import {compactNumberFormatter, ValueFormatter} from '@epic-visualizations/charts';

import {TickProps} from './types';

export interface GetCompactYAxis {
    tickLine: boolean;
    width: number;
    tick: FC<TickProps>;
}

export type GetCompactYAxisParams = (params: {
    yAxisProps?: object;
    visualizationsTheme: VisualizationsTheme;
    yTickFormatter: ValueFormatter<string>;
}) => GetCompactYAxis;

export const getCompactYAxis: GetCompactYAxisParams = ({
    visualizationsTheme,
    yAxisProps,
    yTickFormatter = compactNumberFormatter()
}) => {
    return {
        tickLine: false,
        width: 1,
        tick: (props: TickProps) => {
            const {index, visibleTicksCount, payload, ...rest} = props;

            delete rest.verticalAnchor;
            delete rest.tickFormatter;

            if (index < visibleTicksCount - 1) {
                return null;
            }

            return (
                <text
                    {...rest}
                    fill={visualizationsTheme.axisLabel}
                    fontSize={visualizationsTheme.axisFontSize}
                    textAnchor="start"
                    x="5"
                    dx="0"
                    dy="-15">
                    {yTickFormatter(payload.value)}
                </text>
            );
        },
        ...yAxisProps
    };
};
